export default {
    'add-a-new-customer-type': 'إضافة نوع زبون جديد',
    'type': 'النوع'
}